<template>
    <a-modal title="评价" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="25%">
        <a-form :labelCol="{span:6}" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="12">
                    <a-form-item label="评分" name="evaluate">
                        <a-rate v-model:value="form.evaluate" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="24">
                    <a-form-item :labelCol='{span:3}' label="评分描述" name="baseScoreMsg">
                        <a-textarea v-model:value="form.baseScoreMsg" placeholder="请输入评分描述" :rows="4" />
                    </a-form-item>
                </a-col> -->
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
// import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeConsultation} from "@/api/finance";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            form: {
                id: null,
                evaluate: null,
            },
            rules: {
               id:[],
               evaluate:[],
            },
            submitUrl: financeConsultation.edit
        }
    },
    created() {
    },
    methods: {},
}
</script>
<style scoped lang="less">
</style>
